import { Injectable } from '@angular/core';
import {
	CallbackFormData,
	CallbackOnCallNoteRequestDTO,
	CallerDTO,
	EXECUTION_MODE,
} from '../models/callback-on-callnote.model';
import { ScheduleOptionValueEnum } from '../models/schedule-option.model';
import { convertDateToISOString, convertToServerTimeZone } from '../helpers/date-time.helper';
import { normalizePhoneNumber } from '../helpers/guided-setup.helper';

@Injectable({
	providedIn: 'root',
})
export class CallbackService {
	public prepareCallbackRequestPayload(
		formData: CallbackFormData,
		caller: CallerDTO,
	): CallbackOnCallNoteRequestDTO {
		let notBefore: string | null = null;
		let executionMode: EXECUTION_MODE = 'IMMEDIATE';
		if (formData.selectedScheduleOption === ScheduleOptionValueEnum.SPECIFIC_DATE_TIME) {
			const scheduledDateTime: Date = new Date(formData.schedule.date);
			scheduledDateTime.setHours(
				formData.schedule.time.getHours(),
				formData.schedule.time.getMinutes(),
				0,
				0,
			);

			notBefore = convertDateToISOString(convertToServerTimeZone(scheduledDateTime));
			executionMode = 'STRICT_SCHEDULE';
		}

		return {
			voicemailAllowed: formData.voicemailAllowed,
			executionMode,
			notBefore: notBefore || null,
			person: {
				salutation: caller.salutation || '',
				firstName: caller.firstname || '',
				lastName: caller.lastname || '',
				company: caller.company || '',
			},
			targetPhoneNumbers: (caller.telephoneNumbers || []).map((t) => t.number),
			instructions: formData.customSuggestion,
			/**
			 * Normalised (L5, PS-6495 code review 2): the guided setup accepts the separators people
			 * type, so `+49 (0)30 123-456` goes out as `+4930123456`. Backend-delivered numbers are
			 * already clean and pass unchanged.
			 */
			outgoingNumber: !formData.requestContactForBookingNumber
				? normalizePhoneNumber(formData.outboundOutgoingNumber)
				: '',
			requestContactForBookingNumber: formData.requestContactForBookingNumber,
			// EB-4016: only send the chosen mode in the voicebot case; omit otherwise (null = inherit PS default).
			...(formData.voiceBotMode ? { voiceBotMode: formData.voiceBotMode } : {}),
		};
	}
}
